import { getSVG } from '@/components/Common/styles/mixins';
import clsx from 'clsx';
import React, { FC, RefObject, useImperativeHandle, useRef } from 'react';
import styles from './WidgetNotification.module.scss';

export interface IWidgetProps {
  message: string;
  className?: string;
  widgetRef?: RefObject<{
    getHeight: () => number;
  }>;
}

const WidgetNotification: FC<IWidgetProps> = ({ message, className, widgetRef }) => {
  const ref = useRef<HTMLDivElement>(null);
  useImperativeHandle(
    widgetRef,
    () => ({
      getHeight: () => ref.current?.clientHeight || 0,
    }),
    [],
  );

  return (
    <div className={clsx(styles.container, className)} ref={ref}>
      <div className={styles.innerContainer}>
        <img src={getSVG('/static/images/icon-info-fill-line-2.svg')} alt="아이콘" />
        <div className={styles.message}>{message}</div>
      </div>
    </div>
  );
};

export default WidgetNotification;
